<template>
  <div id="page-wrapper">
    <div class="row page-titles">
      <div class="col-md-5 align-self-center">
        <h3 class="text-themecolor">{{ $t('chop.title') }}</h3>
      </div>
      <div class="col-md-7 align-self-center">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="javascript:void(0)">{{ $t('nav.home') }}</a></li>
          <li class="breadcrumb-item active">{{ $t('chop.title') }}</li>
        </ol>
      </div>
    </div>
    <div class="container-fluid">
      <!-- /row -->
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <div class="card">
            <!--<div class="card-header">
              <div class="pull-right">
                <el-button type="primary" size="small" round @click="apply">{{ $t('chop.apply') }}</el-button>
              </div>
              
            </div>-->
            <div class="card-body">
              <el-row :gutter="20">
                <el-col :span="8" v-for="c in chop" style="margin-top:8px;">
                  <ChopBox :chop="c" @apply-chop="apply" />
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <el-dialog :title="$t('chop.apply')" 
      :visible.sync="showApplyForm"
      width="70%"
      top="30px"
      :append-to-body="true">
            <ChopForm ref="chopForm" :le="currentLegalEntityId" :currentChop="currentChop" @value-save="chopApplied" />
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="applyChop">{{ $t('leaver.save') }}</el-button>
          <el-button @click="showApplyForm = false">{{ $t('leaver.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ChopBox from '@/components/admin/ChopBox.vue'
import ChopForm from '@/components/admin/ChopForm.vue'

export default {
  name: 'ChopList',
  components: {
    ChopBox,
    ChopForm
  },
  data: function() {
  return {
    chop: [],
    showApplyForm: false,
    currentLegalEntityId: null,
    currentChop: null
  }
  },
  computed: {
    
  },
  methods: {
    getChop: function(legalEntityId) {
      let t = this.chop.find(function(obj) {
        return obj.legal_entity_id === legalEntityId
      })
      return t
    },
    chopApplied: function(val) {
      this.showApplyForm = false
    },
    applyChop: function() {
      this.$refs.chopForm.applyChop()
    },
    apply: function(legalEntityId) {
      this.currentLegalEntityId = legalEntityId
      this.currentChop = this.getChop(legalEntityId)
      this.showApplyForm = true
    },
    loadData: function() {
      let that = this

    this.$http.get(this.API3_PREFIX + 'chop').then(function (response) {
    that.chop = response.data
    that.chop.forEach(function(v, i) {
      if (v)
        v.legalEntity = that.getLegalEntity(v.legal_entity_id)
    })
      }).catch(function (error) {
    console.log(error)
      })
    }
  },
  created: function() {
    this.loadData()
  }
}
</script>